<!-- 杠杆式外汇交易账户申请的条款内容 -->
<template>
  <div class="article-content">
    <!-- TODO checkbox样式丢失 -->
      <div class="article" v-html="$t('applyTradeAccount.mt5ApplyForm.articleContent')">
      </div>
        <div class="apply-btn" v-show="isShowButton">
          <el-button @click="$emit('submitForm')" test_id= "createAccount">
            {{status==='reject'?$t('applyTradeAccount.reSubmit'):$t('applyTradeAccount.confirm')}}
          </el-button>
        </div>
  </div>
</template>
<script>
export default {
  props: {
    isFinishRead: {
      type: Boolean,
      default: false
    },
    isShowButton: {
      type: Boolean,
      default: true
    },
    status: {
      type: String,
      default: ''
    }
  }

}
</script>
<style lang="scss" scoped>
.article-content{
  .article{
 color:#24282D;
  // font-weight: bold;
  }
  .statement {
    color: #fec000;
  }
  .font-16 {
    font-size: 16px !important;
  }
  a {
    text-decoration: none;
  }
  .el-checkbox__inner::after {
    height: 12px;
    left: 8px;
    top: 3px;
    width: 3px;
  }
  .el-checkbox__inner {
    width: 22px;
    height: 22px;
  }
  .apply-btn {
    margin-top: 20px;
    .el-button {
      width: 250px;
      height: 56px;
      border-radius: 5px;
      background-color: #fec000;
      color: #182a54;
      font-size: 14px;
      font-weight: 600;
      text-align: center;
      font-family: PingFangSC-Semibold;
    }
  }
}
</style>
